module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-approval"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e2f1273"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/approval/rtApproval.vue
// module id = 2113
// module chunks = 228